import { render } from "./App.vue?vue&type=template&id=57ee808e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=57ee808e&lang=scss"

import exportComponent from "/var/www/production/releases/342/dashboard.jumpfeed.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__